<div class="popup_container" (click)="onClick($event)" [ngClass]="(visibility === 'hidden' ? 'hidden ' : '') + (anchor + '_anchor')" >
  <ng-content select=".content"></ng-content>
</div>
